const normalizePublicUrl = (value) => {
  const normalizedValue = String(value || '').trim();

  if (!normalizedValue || normalizedValue === '.') {
    return '';
  }

  return normalizedValue.replace(/\/+$/g, '');
};

const unregisterServiceWorkers = async () => {
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.unregister()));
};

const register = async () => {
  const serviceWorkerUrl = `${normalizePublicUrl(process.env.PUBLIC_URL)}/service-worker.js`;
  await navigator.serviceWorker.register(serviceWorkerUrl);
};

export const registerServiceWorker = () => {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  const onLoad = async () => {
    try {
      if (process.env.NODE_ENV === 'production') {
        await register();
        return;
      }

      await unregisterServiceWorkers();
    } catch (error) {
      console.error('Nao foi possivel configurar o service worker:', error);
    }
  };

  if (document.readyState === 'complete') {
    onLoad();
    return;
  }

  window.addEventListener('load', onLoad, { once: true });
};
